module.exports = "/_next/static/images/proof-of-identity-d141e439030752d292abc2dde7be1e1c.svg";